import createTracker from '../../analytics/create-tracker';


const track = createTracker('web', 'core');

/**
 * Provide a clean interface for describing the tracking events.
 */
export default {
  continueWithApple: () => track('click_button_apple')
};
